import { Filter, X } from "lucide-react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Combobox } from "@/components/ui/combobox";
import { ApprenticeshipProductType } from "@/types/apprenticeship/product";

export function MapFilters({ defaultValue }: { defaultValue: string | undefined }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [open, setOpen] = useState(false);

    return open ? (
        <div className="flex w-[300px] flex-col rounded-sm border bg-white p-4">
            <Button className="absolute right-1 top-1" onClick={() => setOpen(false)} variant={"ghost"} size={"sm"}>
                <X className="size-4" />
            </Button>
            <div className="space-y-4">
                <div className="space-y-2">
                    <div>
                        <Combobox
                            className="w-[235px]"
                            name="product__in"
                            optionsUrl="/alternance/picklists/products"
                            optionFormatter={(product: ApprenticeshipProductType) => {
                                return { value: product.id.toString(), label: product.short_name || product.name || product.product_code || product.id.toString() };
                            }}
                            defaultValue={defaultValue || searchParams.get("product__in") || undefined}
                            onValueChange={value => {
                                if (value) {
                                    searchParams.set("product__in", value);
                                    setSearchParams(searchParams);
                                } else {
                                    searchParams.delete("product__in");
                                    setSearchParams(searchParams);
                                }
                            }}
                            placeholder="Filtrer par formation"
                        />
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Button onClick={() => setOpen(true)} size="sm" variant="outline">
            <Filter size={20} />
        </Button>
    );
}
